import { Component } from 'react';

// Catches otherwise-unhandled render errors anywhere in the tree. Without
// this, a single throw in a leaf component white-screens the whole app for
// a field rep mid-visit, with no path back except a manual URL reload.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-panel">
          <div className="card p-6 max-w-md w-full text-center space-y-3">
            <div className="text-2xl">⚠</div>
            <h1 className="text-lg font-semibold text-navy">Something went wrong</h1>
            <p className="text-sm text-muted">
              This screen hit an unexpected error. Your notes and data are safe — reloading usually fixes it.
            </p>
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
